import React from 'react';
import { 
  FaUsers, 
  FaCogs, 
  FaChartBar, 
  FaTachometerAlt, 
  FaUserShield,
  FaSignOutAlt,
  FaBell,
  FaHome,
  FaShoppingCart,
  FaEye
} from 'react-icons/fa';

const Sidebar = ({ activeTab, setActiveTab, userRole }) => {
  const menuItems = [
    // Admin menu items
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: FaTachometerAlt,
      roles: ['Admin']
    },
    {
      id: 'users',
      label: 'User Management',
      icon: FaUsers,
      roles: ['Admin']
    },
    {
      id: 'services',
      label: 'Service Management',
      icon: FaCogs,
      roles: ['Admin']
    },
    {
      id: 'sales',
      label: 'Sales Management',
      icon: FaShoppingCart,
      roles: ['Admin']
    },
    {
      id: 'reports',
      label: 'Sales Reports',
      icon: FaChartBar,
      roles: ['Admin']
    },
    {
      id: 'notifications',
      label: 'Notifications',
      icon: FaBell,
      roles: ['Admin']
    },
    // Staff menu items (matching StaffDashboardScreen tabs)
    {
      id: 'overview',
      label: 'Dashboard Overview',
      icon: FaEye,
      roles: ['Staff']
    },
    {
      id: 'sales',
      label: 'Sales Management',
      icon: FaShoppingCart,
      roles: ['Staff']
    },
    {
      id: 'reports',
      label: 'My Reports',
      icon: FaChartBar,
      roles: ['Staff']
    }
  ];

  const filteredMenuItems = menuItems.filter(item => 
    item.roles.includes(userRole)
  );

  return (
    <div className="bg-gradient-to-b from-gray-900 to-gray-800 text-white h-screen w-64 fixed left-0 top-0 shadow-2xl">
      {/* Logo Section */}
      <div className="p-6 border-b border-gray-700">
        <div className="flex flex-col items-center text-center">
          <div className="bg-white px-4 py-2 rounded-xl mb-4">
            <img 
              src="/shahji-logo.png" 
              alt="Shahji Computers" 
              className="h-12 w-auto max-w-32 object-contain"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <FaHome className="text-3xl text-blue-600 hidden" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-white mb-1">Shahji Computers</h1>
            <p className="text-sm text-gray-400">ERP System</p>
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="mt-6">
        <div className="px-4 mb-4">
          <p className="text-xs uppercase text-gray-400 font-semibold tracking-wider">
            Main Menu
          </p>
        </div>
        
        {filteredMenuItems.map((item) => {
          const IconComponent = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`w-full flex items-center space-x-3 px-6 py-3 text-left transition-all duration-200 hover:bg-gray-700 ${
                activeTab === item.id 
                  ? 'bg-blue-600 border-r-4 border-blue-400 text-white' 
                  : 'text-gray-300 hover:text-white'
              }`}
            >
              <IconComponent className="text-lg" />
              <span className="font-medium">{item.label}</span>
            </button>
          );
        })}
      </nav>

      {/* Branding Section */}
      <div className="absolute bottom-0 w-full p-4 border-t border-gray-700">
        <div className="text-center">
          <div className="flex items-center justify-center space-x-1 mb-1">
            <span className="text-xs text-gray-400">Made with</span>
            <span className="text-red-500 text-sm">❤️</span>
            <span className="text-xs text-gray-400">by</span>
          </div>
          <p className="text-sm text-white font-bold italic mb-1">Shahji Computers</p>
          <p className="text-xs text-gray-500">ERP System v1.0</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
